var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1080 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        stroke: #2a4265;\n        stroke-width: 37px;\n      }\n\n      .cls-2, .cls-3 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-4 {\n        fill: url(#New_Gradient_Swatch_1-2);\n      }\n\n      .cls-3 {\n        fill: none;\n        stroke: url(#New_Gradient_Swatch_1);\n        stroke-width: 27px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1",
    "data-name": "New Gradient Swatch 1",
    x1: 24.79,
    y1: 547.33,
    x2: 1048.88,
    y2: 547.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c81515"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bc1111"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "New_Gradient_Swatch_1-2",
    "data-name": "New Gradient Swatch 1",
    x1: 338,
    y1: 546.83,
    x2: 736.37,
    y2: 546.83,
    xlinkHref: "#New_Gradient_Swatch_1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 536.83,
    cy: 547.33,
    r: 451
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 536.83,
    cy: 547.33,
    r: 498.55
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5",
    "data-name": "Layer 5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m544.17,245.78c-1.42-3.82-3.67-5.84-6.12-5.84-2.23,0-4.62,1.68-6.69,5.19-56.81,114.52-115.88,202.42-158.37,288.46-23.84,48.27-35.01,92.85-35,132.66.02,54.33,20.86,99.76,58.77,133.49,37.67,32.04,84.66,52.68,131.9,53.88,2.13.05,4.26.08,6.38.08,56.75,0,113.31-19.31,151.43-63.17,31.68-36.46,49.88-78.9,49.88-128.75,0-38.17-10.68-80.68-34.13-128.19-42.41-85.88-101.35-173.62-158.06-287.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m677.4,705.06c-7.98,26.73-22.42,48.12-33.3,59.27-22.07,22.6-43.26,30.51-57.21,31.91-14.28,1.24-22.37-3.97-25.82-12.14-3.51-8.29-1.45-16.94,5.63-26.35,6.99-9.6,19.13-19.72,34.05-35.04,7.41-7.69,19.52-19.67,29.95-37.39,10.57-17.51,18.87-40.89,22.49-64.62,7.72-46.91-2.46-91.19-2.62-92.47.38,1.19,25.16,38.93,32.66,92.55,3.91,26.93,2.48,57.64-5.83,84.27Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonorIcon);
export default __webpack_public_path__ + "static/media/Donor-Icon.61120184096b0d4b32854ea69345ace0.svg";
export { ForwardRef as ReactComponent };